import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../shared/models/response.model';
import { Sequence } from './models/séquence.model';
import { SequenceCreateRequest } from './séquence-form/requests/create-request';
import { SequenceUpdateRequest } from './séquence-form/requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class SequenceService {
  #http = inject(HttpClient);
  readonly BASE_URL = '/séquences';

  trouveParId(idSequence: string) {
    return this.#http.get<Sequence>(this.BASE_URL + '/' + idSequence);
  }

  trouverTous(idModule: string) {
    return this.#http.get<Response<Sequence>>(this.BASE_URL, { params: { idModule } });
  }

  ajouter(data: SequenceCreateRequest) {
    return this.#http.post<Sequence>(this.BASE_URL, data);
  }

  modifier(idSequence: string, data: SequenceUpdateRequest) {
    return this.#http.put<string>(this.BASE_URL + '/' + idSequence, data);
  }

  supprimer(idSequence: string) {
    return this.#http.delete<string>(this.BASE_URL + '/' + idSequence);
  }
}
